import { render, staticRenderFns } from "./BaoCaoTinhHinhTaiChinhSoSanh.vue?vue&type=template&id=cef47020&scoped=true"
import script from "./BaoCaoTinhHinhTaiChinhSoSanh.vue?vue&type=script&lang=js"
export * from "./BaoCaoTinhHinhTaiChinhSoSanh.vue?vue&type=script&lang=js"
import style0 from "./BaoCaoTinhHinhTaiChinhSoSanh.vue?vue&type=style&index=0&id=cef47020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef47020",
  null
  
)

export default component.exports